import { isInsuranceOfferType } from '@phx/data-sources/medication-marketplace';

import { useFillPrescription } from '../../../../contexts/fill/use-fill-prescription';
import type { PrescriptionOffer } from '../../../../hooks/use-prescription-offers';
import type { PricingCardProps } from '../common/shared';

export type UseInsurancePricing = {
    patientPay: number | null;
    priceType: PrescriptionOffer['headlinePriceType'];
};

export const useInsurancePricing = (
    offer: PricingCardProps['offer']
): UseInsurancePricing => {
    const { allOffers } = useFillPrescription();

    const insuranceOffers = allOffers.filter((offer) =>
        isInsuranceOfferType(offer.headlinePriceType)
    );

    const copayOffer = insuranceOffers.find(
        (o) => o.headlinePriceType === 'CopayAssistance'
    );

    if (offer?.patientCost) {
        return {
            patientPay: offer.patientCost,
            priceType: offer.headlinePriceType,
        };
    }

    if (copayOffer?.patientCost) {
        return {
            patientPay: copayOffer.patientCost,
            priceType: copayOffer.headlinePriceType,
        };
    }

    return { patientPay: null, priceType: null };
};
